<template>
  <v-row dense>
    <v-col v-if="imgUrl" cols="12">
      <v-img :src="imgUrl" cover :eager="true" :class="classes" />
    </v-col>

    <v-col v-else-if="messageContent" cols="12">
      <v-list-item-content v-text="messageContent" />
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'ScreenShotPost',

  props: {
    imgUrl: {
      type: String,
      required: true,
    },
    messageContent: {
      type: String,
      default: () => '',
    },
    classes: {
      type: String,
      default: '',
    },
  },
}
</script>
